import { CDButton, CDTypography } from "@cdatacloud/component-library";
import {
  CDataModalV2,
  ICDataModalV2Props,
} from "src/components/modal/CDataModalV2";
import { IInitiateOAuthResponseCorrect } from "src/pages/connections/api/oauth/getOAuthAuthorizationUrl";

export type OAuthModalProps = Pick<
  ICDataModalV2Props,
  "close" | "displayed"
> & {
  driverName: string;
  oauthResponse: IInitiateOAuthResponseCorrect | null | undefined;
};

/** Modal that shows up when  */
export function OAuthWaitModal(props: OAuthModalProps) {
  const { driverName, displayed, close, oauthResponse } = props;

  return (
    <CDataModalV2
      title={`Waiting for ${driverName} Credentials`}
      displayed={displayed}
      close={close}
      displayToggleCloseButton={false}
      spacedFooter={false}
      secondaryButton={
        <CDButton
          color="Secondary/Text Regular"
          onClick={() => {
            close();
          }}
        >
          Cancel
        </CDButton>
      }
    >
      <CDTypography>
        Please complete the sign-in flow in the other tab in order to set up
        access to your {driverName} account. If you are not automatically taken
        to a new tab,
        <a
          className="card-setting"
          onClick={() => window.open(oauthResponse?.oauthUrl, "_blank")}
        >
          {" "}
          click here.
        </a>
      </CDTypography>
    </CDataModalV2>
  );
}
